import { render, staticRenderFns } from "./ButtonSubMerchant.vue?vue&type=template&id=e06de4ce&scoped=true&"
import script from "./ButtonSubMerchant.vue?vue&type=script&lang=js&"
export * from "./ButtonSubMerchant.vue?vue&type=script&lang=js&"
import style0 from "./ButtonSubMerchant.vue?vue&type=style&index=0&id=e06de4ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06de4ce",
  null
  
)

export default component.exports